module.exports = __webpack_public_path__ + "media/images/signatures/cover-bg-3-e8747162344a338b5ff65a23d1cecb5e.png";